/**
 * Represents Hybrid Routes Manager
 */
class HybridRoutesMgr {
	private routes: Array<string>;

	/**
	 * @constructor
	 */
	constructor(routes = []) {
		this.routes = routes;
	}

	/**
	 * Match url from the list of routes
	 * @param {string} url url
	 * @returns {boolean} is url matched
	 */
	matchRoute(url: string): boolean {
		return this.routes.some((route) => {
			return url.indexOf(route) !== -1;
		});
	}
}

export default HybridRoutesMgr;
